module.exports = __webpack_public_path__ + "static/media/sunrise.5dff2cb5.svg";